import React from 'react'

export default function CTA() {
    const handleGetStartedClick = () => {
        const event = new CustomEvent('toggleDemo');
        window.dispatchEvent(event);
    
        document.getElementById('hero').scrollIntoView({ behavior: 'smooth' });
      };
    

  return (
    <div className="relative overflow-hidden border-b w-full bg-gradient-to-b from-blue-50 to-white">
      <div className="px-6 py-8 sm:px-6 sm:py-20">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl font-semibold tracking-tight text-center text-black sm:text-4xl dark:text-white">
            Start Your Global Expansion Journey
          </h2>
          <p className="max-w-xl mx-auto mt-3 text-gray-700 sm:mt-6 text-md sm:text-lg sm:leading-snug dark:text-gray-300">
            Get started with Cross Intelligence and unlock the power of AI-driven insights for your global business.
          </p>
          <div className="flex items-center justify-center mt-6 sm:mt-10 gap-x-6">
            <button
              onClick={handleGetStartedClick}
              className="flex flex-row items-center justify-center min-w-[130px] rounded-full border disabled:cursor-not-allowed disabled:opacity-50 transition ease-in-out duration-150 text-base bg-black text-white font-medium tracking-wide border-transparent py-1.5 h-[38px] hover:text-gray-200 dark:bg-white dark:text-black dark:hover:text-gray-700 px-8 z-20 "
            >
              Try Demo Now
            </button>
          </div>
        </div>
      </div>
      <svg
        viewBox="0 0 1024 1024"
        className="absolute left-1/2 z-10 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2 [mask-image:radial-gradient(closest-side,white,transparent)]"
        aria-hidden="true"
      >
        <circle
          cx={512}
          cy={512}
          r={512}
          fill="url(#827591b1-ce8c-4110-b064-7cb85a0b1217)"
          fillOpacity="0.7"
        ></circle>
        <defs>
          <radialGradient id="827591b1-ce8c-4110-b064-7cb85a0b1217">
            <stop stopColor="#3b82f6" />
            <stop offset={1} stopColor="#1d4ed8" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
}